import React from 'react';

/*
  Shared empty-state block. Centered icon + headline + helper copy + CTA.
  Render inside a panel (e.g. a Card) — it provides the centered layout and
  spacing but no border/background of its own.

  Props:
    icon     — optional lucide icon component (the component, not an instance)
    title    — short headline
    subtitle — optional helper copy
    cta      — optional JSX (button, link)
*/

export default function XpnsrEmpty({ icon: Icon, title, subtitle, cta }) {
  return (
    <div className="xp-empty" data-testid="empty-state">
      {Icon ? <Icon className="xp-empty-icon" /> : null}
      <h3>{title}</h3>
      {subtitle ? <p>{subtitle}</p> : null}
      {cta ? <div className="xp-empty-cta">{cta}</div> : null}
    </div>
  );
}
